import { Injectable } from '@angular/core';
import { ApiService } from '../api.service';

@Injectable({
  providedIn: "root"
})
export class ProductService {

  constructor(private httpService: ApiService) { }

  postProductList(objectPassed){
    const  url = `product`
    return this.httpService.postForShopService(url, objectPassed);
  }

  getProductInfoGetUsingId(idPassed){
    const  url = `product/${idPassed}`
    return this.httpService.getForShopService(url);
  }
  getProductInfoGetUsingSlug(slugPassed){
    const  url = `product/${slugPassed}`
    return this.httpService.getForShopService(url);
  }

  postProductCustomerRating(idPassed){
    const  url = `rating/product/count/${idPassed}`
    return this.httpService.getDigi(url);
  }

  postCategoryOfProducts(objectPassed){
    const  url = `category/used`
    return this.httpService.postForShopService(url, objectPassed);
  }
  getCategories(){
    const  url = `category/used`
    return this.httpService.getForShopService(url);
  }
  postProducts(objectPassed){
    const  url = `product`
    return this.httpService.postForShopService(url, objectPassed);
  }
}
